import { StrictMode } from 'react'
import reactDOM from 'react-dom/client'

import 'altcha'

import { App } from './App'

import 'antd/dist/reset.css'

const rootElement = document.getElementById('root')

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.info('Service Worker registrado con éxito:', registration)
      })
      .catch((error) => {
        console.error('Error al registrar el Service Worker:', error)
      })
  })
}

if (rootElement !== null) {
  reactDOM.createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
} else {
  console.error('ERROR', 'Root element not found')
}
